import { useProfile } from 'hooks'
import { EShiftSession } from 'pages/menuWorkingSchedule/enums'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const StyledSpanShift = styled.span`
  font-weight: 700;
  margin-right: 12px;
  span {
    font-weight: 400;
    margin-left: 4px;
  }
`
interface IProps {
  color?: 'blue' | 'green' | 'red'
  title?: string
  value?: number
  className?: string
}
const ClinicShift = (props: IProps) => {
  const { className } = props
  const { profile } = useProfile()

  const morningShift = profile?.shifts?.find(
    (shift) => shift?.shift === EShiftSession.MorningShift
  )
  const afternoonShift = profile?.shifts?.find(
    (shift) => shift?.shift === EShiftSession.AfternoonShift
  )
  const allDayShift = profile?.shifts?.find(
    (shift) => shift?.shift === EShiftSession.AllDay
  )
  const { t } = useTranslation()
  return (
    <div className={className}>
      <StyledSpanShift>
        {t('morning-shift')}:
        <span>
          {morningShift?.from}-{morningShift?.to}
        </span>
      </StyledSpanShift>
      <StyledSpanShift>
        {t('afternoon-shift')}:
        <span>
          {afternoonShift?.from}-{afternoonShift?.to}
        </span>
      </StyledSpanShift>
      <StyledSpanShift>
        {t('all-day-shift')}:
        <span>
          {allDayShift?.from}-{allDayShift?.to}
        </span>
      </StyledSpanShift>
    </div>
  )
}

export default ClinicShift
